var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSupportUser
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "pt-5" },
            [
              _c("Multiselect", {
                attrs: {
                  options: _vm.users,
                  "hide-selected": true,
                  multiple: true,
                  "close-on-select": false,
                  "clear-on-select": false,
                  "show-labels": false,
                  "preserve-search": true,
                  placeholder: "Please Select At Least One User",
                  "track-by": "userId",
                  label: "username",
                },
                model: {
                  value: _vm.usersWithAccess,
                  callback: function ($$v) {
                    _vm.usersWithAccess = $$v
                  },
                  expression: "usersWithAccess",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "pt-5" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: {
                  click: function ($event) {
                    return _vm.updateUserAccess(_vm.usersWithAccess)
                  },
                },
              },
              [_vm._v("Update User Access")]
            ),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v(" You do not have permissions on this page ")]
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "subtitle" }, [
        _vm._v("Users With Access To Xero Export"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }